/* ---------- src/store/cotizacion.js ---------- */
import { defineStore } from "pinia";
import { ref, computed } from "vue";

/* ①  importa los 4 catálogos para poder resolver la categoría */
import productosGenerales from "@/data/productosGenerales";
import productosAgricola from "@/data/productosAgricola";
import productosAutomotriz from "@/data/productosAutomotriz";
import productosIndustrial from "@/data/productosIndustrial";

export const useCotizacionStore = defineStore(
  "cotizacion",
  () => {
    const productosSeleccionados = ref([]);

    /* ---------- helper: busca la categoría given a slug ---------- */
    const categoriaDe = (slug) => {
      const bases = [
        ...productosGenerales,
        ...productosAgricola,
        ...productosAutomotriz,
        ...productosIndustrial,
      ];
      for (const cat of bases) {
        if (cat.productos.some((p) => p.slug === slug)) return cat.categoria;
      }
      return "Otros";
    };

    /* ---------- add / remove ---------- */
    const addProducto = (producto) => {
      if (productosSeleccionados.value.find((p) => p.slug === producto.slug))
        return;

      /* ②  si viene sin categoria, la resolvemos antes de guardar */
      if (!producto.categoria) {
        producto = { ...producto, categoria: categoriaDe(producto.slug) };
      }
      productosSeleccionados.value.push(producto);
    };

    const removeProducto = (slug) => {
      productosSeleccionados.value = productosSeleccionados.value.filter(
        (p) => p.slug !== slug
      );
    };

    const clear = () => {
      productosSeleccionados.value = [];
    };

    const total = computed(() => productosSeleccionados.value.length);

    return {
      productosSeleccionados,
      addProducto,
      removeProducto,
      clear,
      total,
    };
  },
  {
    persist: true, // ⬅️  sigue guardando en localStorage
  }
);
